module.exports = __webpack_public_path__ + "static/media/tyr.45f9b579.gif";